import React, { useEffect, useState, useRef, memo } from 'react'
import { useNavigation } from '../../../hooks/useWebNavigation'
import { useSelector } from 'react-redux'
import { StyleSheet, Text, View, TouchableOpacity, ImageBackground } from 'react-native'
import { Dimensions } from 'react-native'
import { save_survey_request } from '../../learning/services'
import { save_survey_local, get_all_surveys } from '../../../db/learning/index'
import { openDB } from '../../../db/indexDB'
import NetInfo from '@react-native-community/netinfo'
import { MaterialCommunityIcons } from '@expo/vector-icons'
import theme from '../../../../theme'
import styles from './PostSurveysStyles'
import { fetchAuthSession } from 'aws-amplify/auth'
import { getLanguage } from '../../appBar/context/LocalizationContext'
import { colorText } from '../../../../themeConstants'
import { ScrollView } from 'react-native-gesture-handler'

export default function PostSurvey({ Survey, handleComplete, post_id }) {
    //const token = useSelector((state) => state.auth.authToken)
    const { languageFile } = getLanguage()
    const navigation = useNavigation()
    const [currentQuestion, setCurrentQuestion] = useState(0)
    const [score, setScore] = useState(0)
    const [assessmentResult, setAssessmentResult] = useState({
        isApproved: false,
        totalScore: 0,
        userScorePercentage: 0,
    })
    const [showScore, setShowScore] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [currentEvaluation, setCurrentEvaluation] = useState(null)
    const [course, setCourse] = useState(null)
    const [selectedOptions, setSelectedOptions] = useState([])
    const [database, setDatabase] = useState(null)
    const [connect, setConnect] = useState(false)
    // Obtener la evaluación al cargar el componente
    const surveyData = currentEvaluation ? currentEvaluation['questions'] : null

    const handleAnswer = async (selectedAnswer) => {
        const answer = surveyData[currentQuestion]
        let all_answers = [...selectedOptions, { question: currentQuestion, question_id: answer._id, question_text: answer.title, selectedAnswer }]
        console.log('🚀 ~ handleAnswer ~ all_answers:', all_answers.length)
        setSelectedOptions((prevSelectedOptions) => [
            ...prevSelectedOptions,
            { question: currentQuestion, question_id: answer._id, question_text: answer.title, selectedAnswer },
        ])

        const nextQuestion = currentQuestion + 1
        if (nextQuestion < surveyData.length) {
            setCurrentQuestion(nextQuestion)
        } else {
            // TERMINO DE RESPONDER TODO
            setShowScore(true)
            console.log('fin de la evaluacioooon')
            await save_evaluation(connect, all_answers)
            handleComplete()
        }
    }
    const save_evaluation = async (connect, answers) => {
        console.log(answers.length, '🚀 ~ constsave_evaluation= ~ answers:', answers)
        let status_send = 0
        if (connect) {
            const session = await fetchAuthSession()
            const authToken = session.tokens?.accessToken?.toString()
            const data = {
                authToken: authToken,
                post_id: post_id ? post_id : null,
                survey_id: Survey._id,
                answers: answers,
            }
            let save_assessment = await save_survey_request(data)
            if (save_assessment && save_assessment.status == 1) {
                status_send = 1
                setAssessmentResult(save_assessment.single)
            }
            console.log('Entre al conectado')
        }
        if (status_send == 0) {
            const db = await openDB()
            console.log('Guardo en local')

            //GUARDO LA EVALUACION SOLO EN LOCAL PARA QUE SE ENVIE CUANDO TENGO CONEXION
            console.log('estoy sin conexion guardo encuesta en local')
            const data = {
                _id: Survey._id,
                post_id: post_id,
                answers: JSON.stringify(selectedOptions),
            }
            await save_survey_local(db, data)
            let encuestas_en_local = await get_all_surveys(db)
            console.log('🚀 ~ encuestas_en_local= ~ encuestas_en_local:', encuestas_en_local)
        }
    }

    const SurveyComplete = () => {
        if (connect) {
            const backgroundColor = theme.colors.colorPrimary
            return (
                <ImageBackground source={require('../../../../assets/backgroundSurvey.png')} style={styles.backgroundImage}>
                    <View style={[{ flex: 1, width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }]}>
                        <MaterialCommunityIcons name='tooltip-check-outline' size={150} color={colorText} />
                        <Text style={styles.feedback}>{languageFile.full_survey}</Text>
                        <Text style={styles.feedbackText}>{languageFile.thanks_for_participating}</Text>
                    </View>
                </ImageBackground>
            )
        } else {
            const backgroundColor = theme.colors.colorPrimary
            return (
                <ImageBackground source={require('../../../../assets/backgroundSurvey.png')} style={styles.backgroundImage}>
                    <View style={[{ flex: 1, width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }]}>
                        <MaterialCommunityIcons name='upload-off-outline' size={150} color={colorText} />
                        <Text style={styles.feedback}>{languageFile.full_survey}</Text>
                        <Text style={styles.feedbackText}>{languageFile.sent_automatically}</Text>
                    </View>
                </ImageBackground>
            )
        }
    }

    const UserConnect = async () => {
        try {
            const netInfoState = await NetInfo.fetch()
            setConnect(netInfoState.isConnected)
        } catch (error) {}
    }

    useEffect(() => {
        Survey.completed && setShowScore(Survey.completed)
        UserConnect()
        setCurrentEvaluation(Survey)
    }, [])

    return (
        <ImageBackground source={require('../../../../assets/backgroundSurvey.png')} style={styles.backgroundImage}>
            <View style={{ flex: 1, width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }}>
                <>
                    {currentEvaluation && currentEvaluation.questions ? (
                        showScore || currentEvaluation.completed ? (
                            <SurveyComplete />
                        ) : (
                            <View
                                style={[
                                    styles.questionContainer,
                                    { flex: 1, width: '80%', height: '100%', alignItems: 'center', justifyContent: 'center' },
                                ]}
                            >
                                <Text style={styles.optionText}> {currentEvaluation.questions[currentQuestion]?.title} </Text>
                                {/* <ScrollView style={{ width: '100%', maxHeight: '60%' }} showsVerticalScrollIndicator={false}> */}
                                {currentEvaluation.questions[currentQuestion]?.secondary_actions.map((item) => (
                                    <TouchableOpacity
                                        onPress={() => handleAnswer(item)}
                                        style={[styles.optionContainer, { width: '100%' }]}
                                        key={item.label}
                                    >
                                        <Text style={[styles.options]}> {item.label} </Text>
                                    </TouchableOpacity>
                                ))}
                                {/* </ScrollView> */}
                            </View>
                        )
                    ) : (
                        <Text style={styles.optionText}>{languageFile.loading_evaluation}</Text>
                    )}
                </>
            </View>
        </ImageBackground>
    )
}
